// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1PxPJ","inner":"Form_inner__14Hoe","range":"Form_range__1ujU4","name":"Form_name__23N_z","actions":"Form_actions__2MTB8"};